import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CheckIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    title={t`Check`}
    {...props}
    testID={props.testID || "check-icon"}
  >
    <Path
      fill="currentColor"
      d="M10.97 4.97a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06L6.5 9.44l4.47-4.47Z"
    />
  </Icon>
);
